import { Logo } from '@/components/icons'
import * as React from 'react'

const Navbar: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
	<div className="flex h-20 items-center md:w-[240px] md:max-w-[240px] bg-white md:flex-col md:h-full md:min-h-dvh w-full text-[#808080] md:items-center shadow-container">
		<div className="hidden md:mt-5 md:mb-9 md:block">
			<Logo />
		</div>
		<div className="flex items-end justify-around w-full md:justify-start md:items-center md:flex-col sm:gap-2">
			{children}
		</div>
	</div>
)

export default Navbar
